import { createSlice } from '@reduxjs/toolkit';

interface State {}
const initialState = (): State => ({});

const slice = createSlice({
  name: 'CLINICAL_MEETING_ACTIVITIES',
  initialState,
  reducers: {},
  extraReducers(build) {},
});
// export const {} = slice.actions;
export const clinicalMeetingActivitiesReducer = slice.reducer;
